import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default {
  namespaced: true,

  state: () => {
    return {};
  },

  actions: {
    async getDrydockStats({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/drydock/monitor',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response;
    },

    async getDrydockSummary({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/drydock/summary',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response;
    },

    async getDrydockStays({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/drydock/stays',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      response.data.data = response.data.stays;
      return response;
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        'api/apiRequest',
        {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL_V2},
        { root: true },
      );
    },
  },
}
